export enum DarkModeEnum {
  DARK = 'dark',
  LIGHT = 'light',
  MIDNIGHT = 'midnight',
  AUTO = 'auto',
}
